import { useRef, useEffect, useState } from "react";
import "../BuiltToGrow.css";
import girl_pen_on_battery from "../../../assets/girl_pen_on_battery.png";
import icon_tick from "../../../assets/icon_tick.png";
import builtBg from "../../../assets/built_bg_luxury_home.jpg";

export default function BuiltToGrow() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`built-proven-brands-section ${inView ? "built-in-view" : ""}`}
      style={{ backgroundImage: `url(${builtBg})` }}
    >
      <div className="built-bg-overlay" />
  <div className="built-proven-brands-section-inner">
    <div className="built-brands-content">

      {/* LEFT */}
      <div className="built-brands-info-card">
        <h2>Built to Grow with Your Home</h2>

        <div className="built-feature-row">
          <img src={icon_tick} alt="icon" className="built-feature-icon" />
          <p className="built-info-footer-list">
          GoodWe has a strong presence in Australia, with <span className="built-highlight">CEC-approved systems</span> and a growing reputation for reliable solar and storage solutions.
          </p>
        </div>

        <div className="built-feature-row">
          <img src={icon_tick} alt="icon" className="built-feature-icon" />
          <p className="built-info-footer-list">
          A <span className="built-highlight">local Australian support team backs the ESA series</span>, ensuring long-term reliability and manufacturer warranty coverage for peace of mind.
          </p>
        </div>

        <div className="built-feature-row">
          <img src={icon_tick} alt="icon" className="built-feature-icon" />
          <p className="built-info-footer-list">
          The ESA platform supports <span className="built-highlight">whole-home backup</span> and <span className="built-highlight">grid-interactive features</span>, helping future-proof your energy setup.
          </p>
        </div>
      </div>

      {/* RIGHT */}
      <div className="built-brands-image-container">
        <img
          src={girl_pen_on_battery}
          alt="Modern home with solar battery system"
          className="built-brands-image"
        />
      </div>

    </div>
  </div>
</div>


  );
}
